(function () {
    'use strict';

    angular
        .module('app')
        .controller('HostController', HostController);

    HostController.$inject = ['$http', '$stateParams', '$rootScope', '$scope', 'authenticator', '$sce', '$state', 'dateParser', '$cookies', 'cache', 'dialog', 'eventTracker'];

    function HostController($http, $stateParams, $rootScope, $scope, authenticator, $sce, $state, dateParser, $cookies, cache, dialog, eventTracker) {
        var vm = this;
        vm.favourite = favourite;
        vm.backToEdit = backToEdit;
        vm.loadMorePastConcerts = loadMorePastConcerts;
        vm.showLessPastConcerts = showLessPastConcerts;
        vm.createConcert = createConcert;
        vm.$onInit = init;
        vm.reviews = [];
        vm.showUserProfile = [];
        vm.loadedConcerts = 0;
        vm.concertsPerRow = 3;
        vm.current_image_up = current_image_up;
        vm.current_image_down = current_image_down;
        vm.is_first_image = is_first_image;
        vm.is_last_image = is_last_image;
        vm.copyLink = copyLink;
        vm.closeSharePopup = closeSharePopup;
        vm.toggleFollow = toggleFollow;
        vm.superHostInfo = function SuperHostInfo(e) {
            e.preventDefault();
            e.stopPropagation();
            dialog.info('superhost-info');
        }

        function init() {
            $rootScope.header_inverted = false;
            $rootScope.on_dashboard = false;
            $rootScope.separate_page = false;
            $rootScope.dark_text_header = true;
            vm.is_preview = $state.current.name === 'space_preview';
            vm.space_slug = $stateParams.space_slug;
            vm.message = false;

            if(window.innerWidth > 620 && window.innerWidth < 992) {
                vm.concertsPerRow = 2;
            }

            getSpace().then(function () {
                vm.current_image = vm.images[0];

                vm.linksList = [];
                if(vm.space.space_facebook) { vm.linksList.push(vm.space.space_facebook);}
                if(vm.space.space_instagram) { vm.linksList.push("https://www.instagram.com/" + vm.space.space_instagram);}
                if(vm.space.space_link) { vm.linksList.push(vm.space.space_link);}

                vm.reviewList = [];

                vm.genreList = [];
                vm.space.selected_genres.forEach(element => {
                    vm.genreList.push(element.filter_value_name);
                });

                vm.hostJsonId = {
                    "@context": "http://schema.org",
                    "@type": "Place",
                    "name": vm.space.space_name,
                    "description": vm.space.space_description_short,
                    "image": {
                        "@type": "ImageObject",
                        "url": "https://bemyconcert.com/uploads/spaces/" + vm.space_slug + "/" + vm.current_image + "_xl.jpeg"
                    },
                     "logo": {
                        "@type": "ImageObject",
                        "url": "https://bemyconcert.com/uploads/spaces/" + vm.space_slug + "/" + vm.current_image + "_xs.jpeg"
                    },
                    "url": "https://bemyconcert.com/host/" + vm.space.space_slug,
                    "keywords": vm.genreList,
                    "sameAs": vm.linksList
                };
            });
            getConcerts();
            getLoggedIn();
            setSecondaryImageExists();

            var deregister_toggle_message = $scope.$on('toggle_message', function () {
                vm.message = false;
            });

            $scope.$on('$destroy', function () {
                $rootScope.hide_header = false;
                $rootScope.header_inverted = false;
                $rootScope.dark_text_header = false;
                deregister_toggle_message();
            })
        }

        function setSecondaryImageExists() {
            return $http.get('uploads/spaces/' + vm.space_slug + '/2_md.jpeg')
                .then(function (response) {
                    var headers = response.headers();
                    if (headers['image-fallback'] == 'true') {
                        vm.secondary_image_exists = false;
                    } else {
                        vm.secondary_image_exists = true;
                    }
                }).catch(function (response) {
                    vm.secondary_image_exists = false;
                });
        }


        function backToEdit() {
            if ($rootScope.previousState && typeof $rootScope.previousState.name == 'string') {
                // if the previous state has been set in $transitions hook
                return $state.go($rootScope.previousState.name, $rootScope.previousState.params);
            } else {
                return $state.go('member');
            }
        }

        function getLoggedIn() {
            vm.logged_in = ($cookies.get('_user_email_') !== undefined) || ($cookies.get('user_logged_in_with_facebook') !== undefined);
        }

        function getSpace() { //Get data about the space
            return $http.get('api/spaces/' + $stateParams.space_slug + '/')
                .then(function (response) {
                    vm.space = response.data;
                    vm.space_link = response.data.space_share_link;
                    vm.space_link_da = response.data.space_share_link_da;
                    if($stateParams.language == 'da'){
                        vm.mailto_link = "mailto:" + "" +
                                    "?subject=" + vm.space.space_name + " - Be My Concert" +
                                    "&body=" + vm.space_link_da;
                    } else if ($stateParams.language == 'en') {
                        vm.mailto_link = "mailto:" + "" +
                                    "?subject=" + vm.space.space_name + " - Be My Concert" +
                                    "&body=" + vm.space_link;
                    }

                    vm.images = [vm.space.primary_image];
                    vm.images = vm.images.concat(vm.space.secondary_images);

                    window.document.title = vm.space.space_name + " - Be My Concert";

                    if (vm.space.space_deleted_at > '') {
                        return $state.go('item_deleted');
                    }

                    if (vm.space.space_youtube) { //Gets the youtube URL, creates a youtube-embed URL and trusts it
                        var p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
                        vm.yt_stripped = ((vm.space.space_youtube.match(p)) ? RegExp.$1 : false);
                        vm.yt_url = $sce.trustAsResourceUrl('https://www.youtube.com/embed/' + vm.yt_stripped);
                    }

                    if (vm.space.space_facebook && vm.space.space_facebook !== '') {
                        if (!/^https?:\/\//i.test(vm.space.space_facebook)) {
                            vm.space.space_facebook = 'http://' + vm.space.space_facebook;
                        }
                    }

                    if (vm.space.space_link && vm.space.space_link !== '') {
                        if (!/^https?:\/\//i.test(vm.space.space_link)) {
                            vm.space.space_link = 'http://' + vm.space.space_link;
                        }
                    }

                    isFavourite(vm.space.space_slug);
                    getReviews();
                });
        }

        function getReviews() { //Gets all reviews of the current object and returns these
            return $http.get('api/reviewlist/space/' + vm.space.space_slug + '/')
                .then(function (response) {
                    vm.reviews = Object.values(response.data).filter(review => review.review_comment.length > 0);
                    vm.numberOfReviews = Object.keys(vm.reviews).length;
                });
        }

        function favourite() {
            if (!vm.logged_in) {
                var backState = angular.copy($stateParams);
                backState.favorite = true;
                return $state.go('login', { 'backToStateName': 'host', 'backToStateParams': backState });
            }
            $http.post('api/favourites/space/' + $stateParams.space_slug);
            vm.space.favorite = !vm.space.favorite;
            cache.clear('hosts');
        }

        function isFavourite(space_slug) {
            if (!vm.logged_in) return;
            const user_id = parseInt($cookies.get('user_id'));
            $http.get('api/favourites/users/' + user_id + '/space/' + space_slug)
                .then(function (response) {
                    if (response.status === 200) {
                        if (response.data === "false") {
                            vm.space.favorite = false;
                            if ($stateParams.favorite) {
                                favourite();
                            }
                        } else {
                            vm.space.favorite = true;
                        }
                    }
                })

        }

        function getConcerts() { //Get the concerts getting played at the space
            $http.get('api/spaceconcerts/' + $stateParams.space_slug + '/')
                .then(function (response) {
                    vm.concerts = response.data;
                    getRecentConcerts();
                });
        }

        function createConcert() {
            $state.go('create_concert', {space_slug: vm.space.space_slug});
        }

        function getRecentConcerts() { //Get the concerts getting played at the space
            $http.get('api/spaces/' + $stateParams.space_slug + '/recent_concerts/')
                .then(function (response) {
                    vm.all_recent_concerts = response.data;
                    if (vm.all_recent_concerts.length > 0 && Object.values(vm.concerts).length == 0) {
                        vm.recent_concerts = [].concat(vm.all_recent_concerts.slice(0, vm.concertsPerRow));
                    } else if (vm.all_recent_concerts.length > 0 && Object.values(vm.concerts).length % vm.concertsPerRow > 0) {
                        vm.recent_concerts = [].concat(vm.all_recent_concerts.slice(0, vm.concertsPerRow - (Object.values(vm.concerts).length % vm.concertsPerRow)));
                    } else {
                        vm.recent_concerts = [];
                    }
                    vm.loadedConcerts = vm.recent_concerts.length;
                    setFutureAndPastConcerts();
                });
        }

        function loadMorePastConcerts() {
            vm.loadedConcerts += vm.concertsPerRow;
            vm.recent_concerts = vm.all_recent_concerts.slice(0, vm.loadedConcerts);
            setFutureAndPastConcerts();
        }

        function showLessPastConcerts() {
            vm.loadedConcerts = Object.values(vm.concerts).length % vm.concertsPerRow == 1 ? 1 : Object.values(vm.concerts).length == 0 ? vm.all_recent_concerts.length > vm.concertsPerRow ? vm.concertsPerRow : vm.all_recent_concerts.length : 0;
            vm.recent_concerts = vm.all_recent_concerts.slice(0, vm.loadedConcerts);
            setFutureAndPastConcerts();
        }

        function setFutureAndPastConcerts() {
            vm.future_and_past_concerts = vm.concerts && vm.recent_concerts ? Object.values(vm.concerts).concat(vm.recent_concerts) : [];
            if(vm.future_and_past_concerts.length > 0){
                eventTracker.detailView(vm.future_and_past_concerts, "Host Profile Concert List");
            }
        }

        function is_first_image() {
            return vm.images ? vm.current_image == vm.images[0] : false;
        }

        function is_last_image() {
            return vm.images ? vm.current_image == vm.images[vm.images.length -1] : false;
        }

        function current_image_up(){
            if(is_last_image()){
                return;
            }
            vm.current_image = vm.images[vm.images.indexOf(vm.current_image) + 1];
        }

        function current_image_down(){
            if(is_first_image()){
                return;
            }
            vm.current_image = vm.images[vm.images.indexOf(vm.current_image) - 1];
        }

        function copyLink(){
            navigator.clipboard.writeText(vm.space_link);
            vm.link_copied = 1;
        }

        function closeSharePopup(){
            vm.link_copied = 0;
            vm.show_share_popup = 0;
        }

        function toggleFollow() {
            if (!vm.logged_in) {
                var backState = angular.copy($stateParams);
                return $state.go('login', { 'backToStateName': 'host', 'backToStateParams': backState });
            }
            $http.post('api/follow/space/' + vm.space.space_slug);
            vm.space.following = !vm.space.following;
        }
    }
})();
